import { ACTION, ENCRYPTION_CMS_KEY } from "./constants";
import request from "../../../../utils/request";
import { requestConfig } from "../../../../config/apiResource";
import { showMainLoader, hideMainLoader } from "../../../actions";
import { formDataGenerator } from "../../../../utils/common";

export function sendLearnToolsOtp(formData) {
  return (dispatch) => {
    return request(requestConfig.sendOtps(formData))
      .then((json) => {
        json && dispatch({ type: ACTION.LEARN_STNDOTP, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with Top up SIP Calculator data: " + error);
      });
  };
}
export function clearSendLearnToolsOtp() {
  return {
    type: ACTION.CLEAR_LEARN_STNDOTP,
  };
}
export function sendLearnToolsVerifyOtp(formData) {
  return (dispatch) => {
    return request(requestConfig.sendLearnToolsVerifyOtp(formData))
      .then((json) => {
        json && dispatch({ type: ACTION.LEARN_VERIFYOTPDATA, data: JSON.parse(getCmsDataDescypt(json.data)) });
        return JSON.parse(getCmsDataDescypt(json.data));
      })
      .catch((error) => {
        console.log("Got Error with Top up SIP Calculator data: " + error);
      });
  };
}
export function clearSendLearnToolsVerifyOtp() {
  return {
    type: ACTION.CLEAR_LEARN_VERIFYOTPDATA,
  };
}
export function postCallBack(formData) {
  return (dispatch) => {
    dispatch(showMainLoader());
    return request(requestConfig.postCallBack(formData))
      .then((json) => {
        dispatch(hideMainLoader());
        json && dispatch({ type: ACTION.TOOLS_CALLBACK, data: json.data });
        return json;
      })
      .catch((error) => {
        dispatch(hideMainLoader());
        console.log("Got Error with Top up SIP Calculator data: " + error);
      });
  };
 }
export function clearPostCallBack() {
  return {
    type: ACTION.CLEAR_LEARN_TOOLS_CALLBACK,
  };
}
export function calculateTopUpSip(lang, formData) {
  return (dispatch) => {
    return request(requestConfig.calculateTopUpSip(lang, formData))
      .then((json) => {
        json && dispatch({ type: ACTION.CALCULATE_TOPUP_SIP, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with Top up SIP Calculator data: " + error);
      });
  };
}

export function getEduCoursesContent(lang) {
  return (dispatch) => {
    return request(requestConfig.getEducationCourses(lang))
      .then((json) => {
        json &&
          dispatch({ type: ACTION.GET_EDU_COURSES_CONTENT, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log(`Got Error with Child education courses Content: ${error}`);
      });
  };
}

export function learnCornerLevels(serverData, formData, typeData) {
  let formDataValue, typeDataValue;
  if (serverData.url) {
    let urlArray = serverData.url.split("/"),
      type = urlArray[urlArray.length - 1];
    typeDataValue = type;

    let data = {
      search: "",
      limit: 8,
      offset: 0,
      tags: "",
    };
    formDataValue = formDataGenerator(data);
  } else {
    formDataValue = formData;
    typeDataValue = typeData;
  }

  return (dispatch) => {
    return request(
      requestConfig.learnCornerLevels(formDataValue, typeDataValue)
    )
      .then((json) => {
        json && dispatch({ type: ACTION.CORNER_LEVELS, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with Top up SIP Calculator data: " + error);
      });
  };
}

export function learnCornerSearch(formData) {
  return (dispatch) => {
    return request(requestConfig.learnCornerSearch(formData))
      .then((json) => {
        json && dispatch({ type: ACTION.CORNER_SEARCH, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with Top up SIP Calculator data: " + error);
      });
  };
}

export function learnCornerLevelsDetail(typeData, urlData) {
  return (dispatch) => {
    return request(requestConfig.learnCornerLevelsDetail(typeData, urlData))
      .then((json) => {
        json && dispatch({ type: ACTION.CORNER_LEVELS_DATA, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with Top up SIP Calculator data: " + error);
      });
  };
}

export function getLearnSubscription(formData) {
  return (dispatch) => {
    return request(requestConfig.getLearnSubscription(formData))
      .then((json) => {
        json && dispatch({ type: ACTION.LEARN_SUBSCRIPTION, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with Top up SIP Calculator data: " + error);
      });
  };
}

export function saveFeedback(formData) {
  return (dispatch) => {
    // dispatch(feedbackLoader());
    return request(requestConfig.saveFeedback(formData))
      .then((json) => {
        // dispatch(hideMainLoader());
        json && dispatch({ type: ACTION.SAVE_FEEDBACK, data: json.data });
        return json;
      })
      .catch((error) => {
        // dispatch(hideMainLoader());
        console.log("Got Error with get in touch: " + error);
      });
  };
}
export function clearsaveFeedback() {
  return {
    type: ACTION.CLEAR_SAVE_FEEDBACK,
  };
}
export function investorawareness(lang) {
  return (dispatch) => {
    return request(requestConfig.investorawareness(lang))
      .then((json) => {
        json && dispatch({ type: ACTION.INVESTOR_AWARENESS, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with investor awareness data: " + error);
      });
  };
}
export function learnInvestorFaqs(formData) {
  return (dispatch) => {
    return request(requestConfig.learnInvestorFaqs(formData))
      .then((json) => {
        json && dispatch({ type: ACTION.LEARN_INVESTOR_FAQS, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with get in touch: " + error);
      });
  };
}
export function getStateCityList(lang) {
  return (dispatch) => {
    return request(requestConfig.getStateCityList(lang))
      .then((json) => {
        json && dispatch({ type: ACTION.GET_STATE_DATA, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with investor awareness data: " + error);
      });
  };
}
export function postSebiRegister(formData) {
  return (dispatch) => {
    return request(requestConfig.postSebiRegisterData(formData))
      .then((json) => {
        json &&
          dispatch({ type: ACTION.POST_SUBMIT_REGISTER_DATA, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log(
          "Got Error with about GET_MARKET_UPDATE_VIDEO data: " + error
        );
      });
  };
}
export function getIapDocuments(formData) {
  let formDataValue;
  if (!__CLIENT__) {
    let data = {
      year: "",
      month: "",
    };
    formDataValue = formDataGenerator(data);
  } else {
    formDataValue = formData;
  }
  return (dispatch) => {
    return request(requestConfig.getIapDocuments(formDataValue))
      .then((json) => {
        json && dispatch({ type: ACTION.GET_IAP_DOWNLOADS, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log(
          "Got Error with about GET_MARKET_UPDATE_VIDEO data: " + error
        );
      });
  };
}

export function getIapDownloadsSearch(formData) {
  return (dispatch) => {
    return request(requestConfig.getIapDownloadsSearch(formData))
      .then((json) => {
        json &&
          dispatch({ type: ACTION.POST_IAP_DOWNLOAD_SEARCH, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log(
          "Got Error with about GET_MARKET_UPDATE_VIDEO data: " + error
        );
      });
  };
}

export function getkeyKnowInfo() {
  return (dispatch) => {
    return request(requestConfig.getkeyKnowInfo())
      .then((json) => {
        json && dispatch({ type: ACTION.GET_KEY_INFORMATION, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log(
          "Got Error with about GET_MARKET_UPDATE_VIDEO data: " + error
        );
      });
  };
}
export function cornerSectionOverview() {
  return (dispatch) => {
    return request(requestConfig.cornerSectionOverview())
      .then((json) => {
        json &&
          dispatch({ type: ACTION.CORNER_SECTION_OVERVIEW, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log(
          "Got Error with about GET_MARKET_UPDATE_VIDEO data: " + error
        );
      });
  };
}

export function learnersCornerList() {
  return (dispatch) => {
    return request(requestConfig.learnersCornerList())
      .then((json) => {
        json && dispatch({ type: ACTION.CORNER_LIST, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log(
          "Got Error with about GET_MARKET_UPDATE_VIDEO data: " + error
        );
      });
  };
}

export function cornerVideoApi(formData) {
  let formDataValue;
  if (!__CLIENT__) {
    let data = {
      search: "",
      limit: 9,
      offset: 0,
    };
    formDataValue = formDataGenerator(data);
  } else {
    formDataValue = formData;
  }
  return (dispatch) => {
    return request(requestConfig.cornerVideoApi(formDataValue))
      .then((json) => {
        json &&
          dispatch({ type: ACTION.CORNER_VIDEO_SECTION, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log(
          "Got Error with about GET_MARKET_UPDATE_VIDEO data: " + error
        );
      });
  };
}

export function cornerVideodetailApi(serverData,typeData) {
  if (serverData.url) {
    let urlArray = serverData.url.split("/");
    typeData = urlArray[urlArray.length - 1];
  }
  return (dispatch) => {
    return request(requestConfig.cornerVideodetailApi(typeData))
      .then((json) => {
        json &&
          dispatch({
            type: ACTION.GET_CORNER_VIDEO_DETAILS,
            data: json.data,
          });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with Top up SIP Calculator data: " + error);
      });
  };
}

export function cornerPodcastApi() {
  return (dispatch) => {
    return request(requestConfig.cornerPodcastApi())
      .then((json) => {
        json &&
          dispatch({ type: ACTION.CORNER_PODCAST_SECTION, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log(
          "Got Error with about GET_MARKET_UPDATE_VIDEO data: " + error
        );
      });
  };
}
export function getCornerPodcastDetails(serverData,typeData) {
  if (serverData.url) {
    let urlArray = serverData.url.split("/");
    typeData = urlArray[urlArray.length - 1];
  }
  return (dispatch) => {
    return request(requestConfig.getCornerPodcastDetails(typeData))
      .then((json) => {
        json &&
          dispatch({
            type: ACTION.GET_CORNER_PODCAST_DETAILS,
            data: json.data,
          });
          return json;
      })
      .catch((error) => {
        console.log("Got Error with Top up SIP Calculator data: " + error);
      });
  };
 }
export function toolsCalculate() {
  return (dispatch) => {
    return request(requestConfig.toolsCalculate())
      .then((json) => {
        json && dispatch({ type: ACTION.TOOLS_CALCULATE, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with Top up SIP Calculator data: " + error);
      });
  };
}
export function getIAPDownloadsMonthsCorner(formData) {
  return (dispatch) => {
    return request(requestConfig.getIAPDownloadsMonthsCorner(formData))
      .then((json) => {
        json &&
          dispatch({ type: ACTION.GET_IAP_MONTH_CORNER, data: json.data });
          return json;
      })
      .catch((error) => {
        console.log("Got Error with Top up SIP Calculator data: " + error);
      });
  };
}

export function getCalculatorMetaData(serverData, typeData) {
  if (serverData.url) {
    let urlArray = serverData.url.split("/");
    typeData = urlArray[urlArray.length - 1];
  }
  return (dispatch) => {
    return request(requestConfig.getCalculatorMetaData(typeData))
      .then((json) => {
        json &&
          dispatch({ type: ACTION.GET_CALCULATOR_METADATA, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with meta data: " + error);
      });
  };
}

export function getMfBytesMetaData() {
  return (dispatch) => {
    return request(requestConfig.getMfBytesMetaData())
      .then((json) => {
        json &&
          dispatch({ type: ACTION.GET_MFBYTES_METADATA, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with meta data: " + error);
      });
  };
}

export function getBookReview(formData) {
  let formDataValue;
  if (!__CLIENT__) {
    let data = {
      search: "",
      sort: "",
      limit: 6,
      offset: 0,
    };
    formDataValue = formDataGenerator(data);
  } else {
    formDataValue = formData;
  }
  return (dispatch) => {
    return request(requestConfig.getBookReview(formDataValue))
      .then((json) => {
        json &&
          dispatch({ type: ACTION.GET_BOOK_REVIEW_DATA, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with Top up SIP Calculator data: " + error);
      });
  };
}

export function getBookReviewDetails(msg) {
  return (dispatch) => {
    return request(requestConfig.getBookReviewDetails(msg))
      .then((json) => {
        json && dispatch({ type: ACTION.BOOK_REVIEW_DETAILS, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with book review details: " + error);
      });
  };
}

export function BookReviewCount(formData) {
  return (dispatch) => {
    return request(requestConfig.BookReviewCount(formData))
      .then((json) => {
        json && dispatch({ type: ACTION.BOOK_REVIEW_COUNT, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with Top up SIP Calculator data: " + error);
      });
  };
}
export function PoetryLounge(formData) {
  return (dispatch) => {
    return request(requestConfig.PoetryLounge(formData))
      .then((json) => {
        json && dispatch({ type: ACTION.POETRY_LOUNGE, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with Poetry lounge data: " + error);
      });
  };
}

export function getTheReadingRoom() {
  return (dispatch) => {
    return request(requestConfig.getTheReadingRoom())
      .then((json) => {
        json &&
          dispatch({ type: ACTION.THE_READING_ROOM, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with meta data: " + error);
      });
  };
}

function aesDecrypt(key, encryptedData, iv) {
  const decrypted = CryptoJS.AES.decrypt(encryptedData, key, { iv: iv });
  return decrypted.toString(CryptoJS.enc.Utf8);
};
function getCmsDataDescypt(inputData) {
if (inputData && inputData.trim() !== '') {
  const splitKeyDataHash = inputData.split('|');
  if (splitKeyDataHash.length >= 2 && splitKeyDataHash[0].trim() && splitKeyDataHash[1].trim()) {
    // For Header
    const iv = CryptoJS.enc.Base64.parse(ENCRYPTION_CMS_KEY.AES_IV);
    const AESkey = CryptoJS.enc.Base64.parse(ENCRYPTION_CMS_KEY.AES_SECRET_KEY);
    const newIVAndKey = aesDecrypt(AESkey, splitKeyDataHash[0], iv);
    // For Data
    const split = newIVAndKey.split('|');
    const iv2 = CryptoJS.enc.Base64.parse(split[0]);
    const AESkey2 = CryptoJS.enc.Base64.parse(split[1]);
    const decryptedData = aesDecrypt(AESkey2, splitKeyDataHash[1], iv2);
    return decryptedData;
  }
} else {
  return ENCRYPTION_CMS_KEY.INVALID_REQUEST;
}
}

function aesEncrypt(key, data, iv) {
  const encrypted = CryptoJS.AES.encrypt(data, key, { iv: iv });
  return encrypted.toString();
}
function getCmsDataEncrypt(inputData) {
  if (inputData && inputData.trim() !== '') {
      // Generate IV and Key for Header
      const headerIV = CryptoJS.lib.WordArray.random(16); // 16 bytes IV
      const headerKey = CryptoJS.lib.WordArray.random(32); // 32 bytes AES Key

      // Encrypt IV and Key using predefined AES_IV and AES_SECRET_KEY
      const iv = CryptoJS.enc.Base64.parse(ENCRYPTION_CMS_KEY.AES_IV);
      const AESkey = CryptoJS.enc.Base64.parse(ENCRYPTION_CMS_KEY.AES_SECRET_KEY);
      const headerEncrypted = aesEncrypt(AESkey, `${headerIV.toString(CryptoJS.enc.Base64)}|${headerKey.toString(CryptoJS.enc.Base64)}`, iv);

      // Encrypt data using headerIV and headerKey
      const iv2 = CryptoJS.enc.Base64.parse(headerIV.toString(CryptoJS.enc.Base64));
      const AESkey2 = CryptoJS.enc.Base64.parse(headerKey.toString(CryptoJS.enc.Base64));
      const dataEncrypted = aesEncrypt(AESkey2, inputData, iv2);

      // Return the combined result
      return `${headerEncrypted}|${dataEncrypted}`;
  } else {
      return ENCRYPTION_CMS_KEY.INVALID_REQUEST;
  }
}

export {getCmsDataDescypt,aesDecrypt,aesEncrypt,getCmsDataEncrypt}